import React from 'react';

import config from '../../config';
import {RouteData} from '../types';
import {
  GLOBAL_HISTORIC_USAGE_PATH,
  GLOBAL_HISTORIC_USAGE_REDIRECT_PATH,
  GLOBAL_HISTORIC_USAGE_REDIRECT_TO_PATH,
  HISTORIC_USAGE_PATH,
  HISTORIC_USAGE_REDIRECT_PATH,
  HISTORIC_USAGE_REDIRECT_TO_PATH,
  STORAGE_EXPLORER_TRACKED_PATH,
  USAGE_PATH,
} from './usagePaths';

const IS_PRIVATE_ENV = config.ENVIRONMENT_IS_PRIVATE;

export const STORAGE_EXPLORER_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'StorageExplorer',
    },
    exact: true,
    isPrivateRoute: false,
    path: [
      USAGE_PATH,
      STORAGE_EXPLORER_TRACKED_PATH,
      '/usage/:entityName/:filePath*',
    ],
    RouteComponent: React.lazy(() => import('../../pages/StorageExplorer')),
  },
  {
    path: '/storage/:entityName/tracked/:filePath*',
    redirect: STORAGE_EXPLORER_TRACKED_PATH,
  },
  {
    path: '/storage/:entityName/:filePath*',
    redirect: '/usage/:entityName/:filePath*',
  },
  {
    path: '/storage/:entityName',
    redirect: '/usage/:entityName',
  },
];

export const HISTORIC_USAGE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'GlobalHistoricUsage',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: GLOBAL_HISTORIC_USAGE_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HistoricUsage/GlobalHistoricUsage')
    ),
  },
  {
    condition: IS_PRIVATE_ENV,
    path: GLOBAL_HISTORIC_USAGE_REDIRECT_PATH,
    redirect: GLOBAL_HISTORIC_USAGE_REDIRECT_TO_PATH,
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrganizationHistoricUsage',
    },
    condition: !IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: HISTORIC_USAGE_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HistoricUsage/OrganizationHistoricUsage')
    ),
  },
  {
    condition: !IS_PRIVATE_ENV,
    path: HISTORIC_USAGE_REDIRECT_PATH,
    redirect: HISTORIC_USAGE_REDIRECT_TO_PATH,
  },
];
